export default {
  props: {
    /**
     * 获取新增行的方法，返回新增行数组,如果是异步获取，就返回一个promise,如果使用该方法，需要使用者自己实现增行中所有的查询逻辑
     */
    // getNewRows: Function,
    /**
     * 获取新增单行的方法，返回一个对象，如果是异步获取，就返回一个promise
     */
    // getNewRow: Function,
    /**
     * 处理新增行的方法，只有在getNewRows是异步的情况下才会调用该方法
     */
    handleAddNewRows: Function,
    /**
     * 新增完成后的回调方法，如果传入了handleAddNewRows方法，该方法就不会被调用
     */
    handleAddNewRowsFinish: Function,
    /**
     * 复制单元格的方法，该方法使用和vxe-table中clip-config的pasteMethod使用方式是一致的，
     * 如果希望最大程度控制复制的逻辑，只需要传入:clip-config={copyMethod: xxx}即可,此时handleCopyMethod将失效
     */
    handleCopyMethod: Function,
    /**
     * 粘贴单元格的方法，该方法使用和vxe-table中clip-config的pasteMethod使用方式是一致的，
     * 不同是在调用该方法前，已经做了单元格是否可以粘贴的校验，如果校验不通过，该方法不会被调用
     * 如果希望最大程度控制粘贴的逻辑，只需要传入:clip-config={pasteMethod: xxx}即可,此时handlePasteMethod将失效
     */
    handlePasteMethod: Function,
    clipConfig: Object,
    menuConfig: {
      type: Object,
      default() {
        return null;
      }
    },
    dynamicStatisticsConfig: Object
  }
};
